import { render, staticRenderFns } from "./IconDownloadBase.vue?vue&type=template&id=62672d37"
import script from "./IconDownloadBase.vue?vue&type=script&lang=js"
export * from "./IconDownloadBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62672d37')) {
      api.createRecord('62672d37', component.options)
    } else {
      api.reload('62672d37', component.options)
    }
    module.hot.accept("./IconDownloadBase.vue?vue&type=template&id=62672d37", function () {
      api.rerender('62672d37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/table/IconDownloadBase.vue"
export default component.exports